import { Action } from '@ngrx/store';

export enum DocumentActionTypes {
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
  DELETE_DOCUMENT_SUCCESS = 'DELETE_DOCUMENT_SUCCESS',
  DELETE_DOCUMENT_FAILURE = 'DELETE_DOCUMENT_FAILURE',
}


export class DeleteDocument implements Action {
  readonly type: DocumentActionTypes = DocumentActionTypes.DELETE_DOCUMENT;
  constructor(public payload: any = null) { }
}

export class DeleteDocumentSuccess implements Action {
  readonly type: DocumentActionTypes = DocumentActionTypes.DELETE_DOCUMENT_SUCCESS;
  constructor(public payload: any = null) { }
}

export class DeleteDocumentFailure implements Action {
  readonly type: DocumentActionTypes = DocumentActionTypes.DELETE_DOCUMENT_FAILURE;
  constructor(public payload: any = null) { }
}

export type DocumentActions =
  | DeleteDocument
  | DeleteDocumentSuccess
  | DeleteDocumentFailure
  ;
